export default __webpack_public_path__ + "static/media/cteni-vety.06c5dd7d.svg";